// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eS_i","delete":"styles_delete__BvjlW","update":"styles_update__2L7GG","add":"styles_add__3Imeb"};